import { z } from 'zod';
import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';
import { zMarshalToNumber, zMarshalToStrictInt } from '../../ReachApi/Marshallers';

export const ZodRadarWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    lat: z.union([z.string(), z.number()]).transform(zMarshalToNumber),
    lng: z.union([z.string(), z.number()]).transform(zMarshalToNumber),
    zoom: z.union([z.string(), z.number()]).transform(zMarshalToStrictInt),
    // TODO: mapType not used.
    mapType: z.string().optional(),
    layers: z.string().transform((layers) => {
        const layersArray = layers.split(',');
        return layersArray.length === 0 ? ['flat', 'radar', 'admin'] : layersArray;
    }),
    from: z.string().optional(),
    to: z.string().optional(),
    animation_duration: z.string().optional(),
});

export type RadarWidgetConfigurationDetails = z.infer<typeof ZodRadarWidgetConfigurationDetails>;

export const ZodRadarWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.RADAR),
    config: ZodRadarWidgetConfigurationDetails,
});

export type RadarWidgetConfiguration = z.infer<typeof ZodRadarWidgetConfiguration>;
